
const Order = (state) => state.Order;
const Orders = (state) => state.Orders;
const TotalInfo = (state) => state.TotalInfo;
export default { Order, Orders, TotalInfo }